<div class="full-width full-height check-block">
  <mat-spinner *ngIf="!status" class="progress" diameter="40" color="primary"></mat-spinner>

  <h3 *ngIf="status" class="center-align">{{status}}</h3>
</div>
